export default __webpack_public_path__ + "static/media/paloma-quiken.42e5d219.svg";